import { DebugUtils } from '@/classes/Utils/DebugUtils.js';

export class PmsAccess extends DebugUtils {

  constructor(debug_flag) {
    super(debug_flag);
    this.pms_response = {};
  }

  // 2025 09 15 t_fieldasync update_pms(api_to_call, action, data) {
// 2025 09 12 userrole added for t_field
  async update_pms(api_to_call, action, data, userrole) {
    try {
      // 2025 09 15 t_field const response = await this.pmsDbAccess(api_to_call, action, data);
      const response = await this.pmsDbAccess(api_to_call, action, data, userrole);
      this.toast_message( { type: 'success', api_to_call, action, data, response:response });
      this.pms_response = { type: 'success', api_to_call, action, data, response:response };
    } catch (error) {
      this.toast_message( { type: 'error', api_to_call, action, data, response: error.message });
      this.pms_response = { type: 'error', api_to_call, action, data, response: error.message };
    }
}

  // 2025 0915 t_field async fetch_pms(api_to_call, action, data) {
// 2025 09 12 userrole added for t_field
async fetch_pms(api_to_call, action, data, userrole) {
        try {
          //console.log('pmsaccess.js:: api_to='+api_to_call)
          // 2025 09 15 const response = await this.pmsDbAccess(api_to_call, action, data);
          const response = await this.pmsDbAccess(api_to_call, action, data, userrole);
          this.toast_message( { type: 'success', api_to_call, action, data, response:response });
          this.pms_response = { type: 'success', api_to_call, action, data, response:response };
        } catch (error) {
          this.toast_message( { type: 'error', api_to_call, action, data, response: error.message });
          this.pms_response = { type: 'error', api_to_call, action, data, response: error.message };
        }
  }

  /*
      if using router, it will be simpler
      now, just send body info along with the path info
  */
  // 2025 09 15 t_field async pmsDbAccess(api_to_call, action, data) {
  // 2025 09 12 userrole added for t_field
  async pmsDbAccess(api_to_call, action, data, userrole) {
    const url = './api/' + api_to_call + '.php';
    //console.log('url = ' + url)
    //console.log(JSON.stringify({action, data}))
    
        const response = await fetch(url, 
          { 
            mode: 'cors',
            method: "POST",
            // 2025 09 15 body: JSON.stringify({action, data})
            body: JSON.stringify({action, data, userrole})
          });
            //console.log('error in roomassign')
            //console.log('response')
            //console.log(response)
        const responseData = await response.json();
        //console.log(responseData)
            //console.log('responsedata')
            //console.log(responseData)
        if (!response.ok) {
            const error = new Error(responseData.message);
            //console.log('error in roomassign')
            //console.log(error)
            throw error;
        }
        return responseData;
  }
}
